import type { AuthUser } from '../services/authService';

export const E2E_AUTH_TOKEN_KEY = 'ecovoz:e2e-token';
export const E2E_MODE_FLAG_KEY = 'ecovoz:e2e-mode';
const E2E_AUTH_TOKEN_VALUE = 'ok';
const E2E_MODE_FLAG_VALUE = '1';
const LOOPBACK_HOSTS = new Set(['127.0.0.1', 'localhost']);
const E2E_AUTH_USER: AuthUser = {
  id: 'e2e',
  name: 'E2E',
  email: 'e2e@local',
  subscriptionStatus: 'active',
  plan: 'familia',
  trialEndsAt: null,
};

const hasLocalE2EModeFlag = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (!LOOPBACK_HOSTS.has(window.location.hostname)) {
    return false;
  }

  return window.localStorage.getItem(E2E_MODE_FLAG_KEY) === E2E_MODE_FLAG_VALUE;
};

export const isE2EModeEnabled = (): boolean =>
  import.meta.env.VITE_E2E === '1' || hasLocalE2EModeFlag();

export const hasE2EAuthToken = (): boolean => {
  if (!isE2EModeEnabled()) {
    return false;
  }

  return window.localStorage.getItem(E2E_AUTH_TOKEN_KEY) === E2E_AUTH_TOKEN_VALUE;
};

export const getE2EAuthUser = (): AuthUser => E2E_AUTH_USER;

export const clearE2EAuthToken = (): void => {
  if (!isE2EModeEnabled()) {
    return;
  }

  window.localStorage.removeItem(E2E_AUTH_TOKEN_KEY);
};
